'use strict';

import * as Colors from './Colors.js';
import {DebuggableObject} from './DebuggableObject.js';

export class PubSub extends DebuggableObject {
    /**
     * @private
     */
    constructor(name) {
        super(name, Colors.violet);
        this.events = {};
    }

    publish(name, ...data) {
        let e = this.events[name];

        if (!e) {
            this.log('no subscribers for \'' + name + '\'');
            return;
        }

        this.log(Colors.green, 'notifying ' + e.length + ' subscribers for \'' + name + '\'', e);
        e.forEach(fn => fn(...data));
    }

    subscribe(name, func) {
        if (!this.events[name]) {
            this.events[name] = [];
        }

        const index = this.events[name].push(func) - 1;

        this.log((index + 1) + '. subscription for "' + name + '"');

        return {
            _index: index,
            name: name,
            remove: () => this.remove(name, index)
        };
    }

    remove(name, index) {
        let e = this.events[name];

        if (e && typeof index === 'undefined') {
            this.log('remove all for "' + name + '"');
            delete this.events[name];
            return true;
        }

        if (e && e[index]) {
            this.log('remove ' + (index + 1) + '. subscriber for "' + name + '"');
            delete e[index];
            return true;
        }

        return false;
    }


    static get instance() {
        return window['PubSub'] ??= new PubSub('PubSub');
    }
}

export const pubsub = PubSub.instance;